// Command Actions
export const executeCommand = 'executeCommand';
export const executeCommandString = 'executeCommandString';
export const parseCommands = 'parseCommands';
export const startSubModule = 'startSubModule';
export const stopSubModule = 'stopSubModule';
export const viewStateSetUiState = 'viewStateSetUiState';
export const setFontSize = 'setFontSize';
export const setColorMode = 'setColorMode';
export const openModal = 'openModal';
export const closeModal = 'closeModal';
export const toggleModal = 'toggleModal';
export const setLanguage = 'setLanguage';
export const setArticleByCode = 'setArticleByCode';
export const setArticle = 'setArticle';
export const setExhibition = 'setExhibition';
export const openUrl = 'openUrl';

// System
export const loadContent = 'loadContent';
export const loadGlossary = 'loadGlossary';
export const loadCalendar = 'loadCalendar';
export const loadPlugin = 'loadPlugin';
export const loadStoreModule = 'loadStoreModule';
export const fetchArticleContent = 'fetchArticleContent';
export const pushUrl = 'pushUrl';
export const setStyleTemplate = 'setStyleTemplate';
export const updateStyleContent = 'updateStyleContent';
export const loadDataSource = 'loadDataSource';
export const setShowLogMessages = 'setShowLogMessages';
export const initializeAnalytics = 'initializeAnalytics';
export const setStyleUrl = 'setStyleUrl';
export const addToMediaObjectMap = 'addToMediaObjectMap';
export const sendErrorMessage = 'sendErrorMessage';

// Player Audio actions
export const audioLoadAndPlayByMediaID = 'audioLoadAndPlayByMediaID';
export const audioLoadAndPlay = 'audioLoadAndPlay';
export const audioClose = 'audioClose';
export const audioTogglePlay = 'audioTogglePlay';
export const audioAutoPlay = 'audioAutoPlay';

// Player Video actions
export const videoLoadAndPlay = 'videoLoadAndPlay';
export const videoToggle = 'videoToggle';
export const videoPlayQueued = 'videoPlayQueued';

// Player Gallery
export const gallerySetIndex = 'gallerySetIndex';
export const galleryNextIndex = 'galleryNextIndex';
export const galleryPrevIndex = 'galleryPrevIndex';
export const gallerySwipe = 'gallerySwipe';
export const gallerySetLayerProp = 'gallerySetLayerProp';
export const gallerySetFigureProp = 'gallerySetFigureProp';
export const galleryToggleHiddenUi = 'galleryToggleHiddenUi';

// Player CustomMap
export const initNavigationMap = 'initNavigationMap';
export const loadCustomMap = 'loadCustomMap';
export const setCustomMapLocationID = 'setCustomMapLocationID';
export const initOnlineGeoMap = 'initOnlineGeoMap';

// Player Map
export const mapFetchPack = 'mapFetchPack';

// Player VR
export const OPEN_VRVIEWER = 'OPEN_VRVIEWER';

// Content modal
export const contentModalSet = 'contentModalSet';
export const contentModalShowGlossary = 'glossaryShowEntry';
export const contentModalClose = 'contentModalClose';

// Bluetooth
export const startBluetooth = 'startBluetooth';
export const stopBluetooth = 'stopBluetooth';

// NearestBeacon Algorithm
export const nearestBeaconStep = 'nearestBeaconStep';

// search
export const searchRefresh = 'searchRefresh';
export const searchShowGlossary = 'searchShowGlossary';
export const searchShowArticles = 'searchShowArticles';
export const searchShowAreaBeacons = 'searchShowAreaBeacons';
export const searchShowCalendar = 'searchShowCalendar';
export const searchShowLocationsByList = 'searchShowLocationsByList';
export const searchShowTour = 'searchShowTour';
export const searchShowExhibitions = 'searchShowExhibitions';
export const searchShowTours = 'searchShowTours';
export const searchShowAllArticles = 'searchShowAllArticles';

// Package Syncer
export const packageSyncerInit = 'packageSyncerInit';
export const _packageSyncerStart = '_packageSyncerStart';
export const packageSyncerStopped = 'packageSyncerStopped';
export const packageSyncerLoad = 'packageSyncerLoad';
export const packageSyncerDelete = 'packageSyncerDelete';

// Progressive Web App
export const progressiveWebAppInit = 'progressiveWebAppInit';
export const _progressiveWebAppStart = '_progressiveWebAppStart';
export const progressiveWebAppStopped = 'progressiveWebAppStopped';
export const progressiveWebAppLoad = 'progressiveWebAppLoad';
export const progressiveWebAppDelete = 'progressiveWebAppDelete';

// scroll
export const scrollSetWrapper = 'scrollSetWrapper';

// loanerStart
export const loanerStart = 'loanerStart';

// Geo Location
export const geoLocationStart = 'geoLocationStart';
export const geoLocationWatch = 'geoLocationWatch';
export const getLocationStop = 'getLocationStop';
export const geoLocationChanged = 'geoLocationChanged';
export const geoLocationRequestPermission = 'geoLocationRequestPermission';

// 3D Player
export const viewer3dLoadID = 'viewer3dLoadID';

// tutorial actions
export const tutorialStart = 'tutorialStart';
export const end = 'end';
export const next = 'next';
export const previous = 'previous';

// tour actions
export const tourStart = 'tourStart';
export const tourEnd = 'tourEnd';
export const tourNext = 'tourNext';
export const tourPrevious = 'tourPrevious';
export const tourSetNavigation = 'tourSetNavigation';
export const tourJumpToPosition = 'tourJumpToPosition';

// quiz actions
export const quizStart = 'quizStart';
export const quizEnd = 'quizEnd';

// swipe actions
export const swipeUpdateArticlePoperties = 'swipeUpdateArticlePoperties';

// Analytics
export const analyticsInitialize = 'analyticsInitialize';
export const analyticsLog = 'analyticsLog';

// MQTT
export const mqttConnect = 'mqttConnect';
export const mqttDisconnect = 'mqttDisconnect';
export const mqttSubscribe = 'mqttSubscribe';
export const mqttUnsubscribe = 'mqttUnsubscribe';
export const mqttHandleMessage = 'mqttHandleMessage';
export const mqttPublish = 'mqttPublish';
export const mqttNext = 'mqttNext';

// Augmented Reality
export const augmentedRealityShowWarning = 'augmentedRealityShowWarning';
export const arCoreKitShowWarning = 'arCoreKitShowWarning';

// ConnectionObersing
export const startObservingConnectionState = 'startObservingConnectionState';
export const stopObservingConnectionState = 'stopObservingConnectionState';
